import React from 'react';

type Props = {
  className?: string;
  color?: string;
};

/**
 * @deprecated Instead, use icons from `cb-icons`.
 */
const Clear = ({ className, color = '#202125' }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      fill={color}
      fillRule="evenodd"
      d="M22 12c0 5.514-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2s10 4.486 10 10zm-6.146-3.146a.502.502 0 0 0-.708-.708L12 11.293 8.854 8.146a.502.502 0 0 0-.708.708L11.293 12l-3.147 3.146a.502.502 0 0 0 .708.708L12 12.707l3.146 3.147a.502.502 0 0 0 .708 0 .502.502 0 0 0 0-.708L12.707 12l3.147-3.146z"
    />
  </svg>
);

export default Clear;
